import type React from "react";
import {memo} from "react";

import {LockIcon} from "../../react/components/Icons/LockIcon";
import Link from "../Link";
import {Badge, BadgeIcon, BadgeText} from "../ui/badge";
import {Tooltip} from "../ui/tooltip";

const ProFeatureLocked: React.FC = () => {
    return (
        <Tooltip
            interaction
            label={
                <>
                    This is a Pro feature. Enable the Pro plan for this listing on the billing page
                    to use this feature.{" "}
                    <Link href="/settings/billing" target="_blank" type="external">
                        View Billing
                    </Link>
                </>
            }
        >
            <Badge variant="outline">
                <BadgeIcon as={LockIcon} />
                <BadgeText>Pro</BadgeText>
            </Badge>
        </Tooltip>
    );
};

export default memo(ProFeatureLocked);
